<template>
  <div class="overview-card">
    <div v-for="(item, index) in cardList" :key="index" class="item">
      <div v-if="item.spacing"></div>
      <div class="top-container" v-if="item.title">
        <div class="title">{{ item.title }}</div>
      </div>
      <div class="content-container" v-if="item.content">
        <div class="content">{{ item.content }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "overview-card",
  props: {
    cardList: Array
  }
};
</script>
<style scoped lang="less">
.overview-card {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .item {
    flex: 1;
    height: 96px;
    margin-right: 16px;
    padding: 16px;
    text-align: left;
    background: #f7f8fa;

    .title {
      height: 22px;
      margin-bottom: 8px;
      color: #4e5969;
      font-weight: 400;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 22px;
    }
    .content {
      height: 24px;
      color: #1d2129;
      font-size: 24px;
      font-family: DINBold;
      line-height: 24px;
    }
  }
}
</style>
